import { useMemo } from "react";

export const useCommentsSkeleton = ({ id }: { id: string }) => {
  return useMemo(() => {
    const label = document.querySelector(`[data-thread-label-id="${id}"]`);
    return !!label;
  }, [id]);
};
